import { AssemblyDisapprovalType } from "../enums/AssemblyDisapprovalType";

//rule: alphabetic order
export const orderTags = {
  amaro: {
    value: 'marketplace_amaro',
    display: 'Amaro',
    css: null
  },
  influenciadores: {
    value: 'influenciadores',
    display: 'Influenciadores',
    css: null
  },
  non_progressive_order_bf2023: {
    value: 'non-progressive-prescription-order-with-more-than-one-lens',
    display: 'Pedidos "não progressiva" com várias lentes',
    css: null
  },
  externally_changed: {
    value: 'alteracao-externa',
    display: 'Alteração externa',
    css: {
      className: 'externally-changed-order',
      primaryColor: '#993399',
      secondaryColor: '#f0ddee'
    }
  },
  pre_sale_sport: {
    value: 'sport',
    display: 'Pré-venda Sport',
    css: {
      className: 'pre-sale-sport-order',
      primaryColor: '#008000',
      secondaryColor: '#dbead5'
    }
  }
};

export const assemblyDisapprovalOptions = [
  { type: AssemblyDisapprovalType.AssemblyProblem, description: 'Problema na Montagem' },
  { type: AssemblyDisapprovalType.LensProblem, description: 'Problema na Lente' },
  { type: AssemblyDisapprovalType.FrameProblem, description: 'Problema na Armação' },
];

export const lensMaterialFilterList = [
  'Policarbonato - Clássico',
  'Policarbonato - Filtro de luz azul',
  'Policarbonato - Acabada AR Padrão',
  'Policarbonato - Acabada AR Filtro Azul',
  'Policarbonato - Surfaçada AR Padrão',
  'Policarbonato - Surfaçada AR Filtro Azul',
  'Resina - Clássico',
  'Resina - Filtro de luz azul',
  'Resina de alto índice - Clássico',
  'Resina de alto índice - Filtro de luz azul',
  'Resina 1.50 - Acabada AR Filtro Azul',
  'Resina 1.56 - Acabada AR Padrão',
  'Resina 1.56 - Acabada AR Filtro Azul',
  'Resina 1.56 - Surfaçada AR Padrão',  
  'Resina 1.56 - Surfaçada AR Filtro Azul',
  'Resina 1.67 - Acabada AR Padrão',
  'Resina 1.67 - Acabada AR Filtro Azul',
  'Resina 1.67 - Surfaçada AR Padrão',
  'Resina 1.67 - Surfaçada AR Filtro Azul',
  'Resina 1.74 - Acabada AR Padrão',
  'Resina 1.74 - Acabada AR Filtro Azul',
  'Sem grau - Filtro de luz azul',
  'Solar com Grau - Policarbonato',
  'Lentes Variadas'
];

export const lensClassFilterList = [
  'Resina 1.56 - Acabada AR Padrão',
  'Resina 1.56 - Acabada AR Filtro Azul',
  'Resina 1.56 - Surfaçada AR Padrão',
  'Resina 1.56 - Surfaçada AR Filtro Azul',
  'Resina 1.56 - Surfaçada Coloração AR Padrão',
  'Resina 1.56 - Surfaçada Coloração AR Filtro Azul',
  'Resina 1.56 - Sem grau - AR Filtro Azul',
  'Resina 1.67 - Acabada AR Padrão',
  'Resina 1.67 - Acabada AR Filtro Azul',
  'Resina 1.67 - Surfaçada AR Padrão',
  'Resina 1.67 - Surfaçada AR Filtro Azul',
  'Resina 1.67 - Surfaçada Coloração AR Padrão',
  'Resina 1.67 - Surfaçada Coloração AR Filtro Azul',
  'Policarbonato - Acabada AR Padrão',
  'Policarbonato - Acabada AR Filtro Azul',
  'Policarbonato - Acabada Coloração AR Padrão',
  'Policarbonato - Surfaçada AR Padrão',
  'Policarbonato - Surfaçada AR Filtro Azul',
  'Policarbonato - Surfaçada Coloração AR Padrão',
  'Policarbonato - Surfaçada Coloração AR Filtro Azul',
  'Policarbonato - Solar com grau',
  'Lentes Variadas'
];